export const CheckLanguageTradingview = (id) => {
  switch (id) {
    case "th":
      return "th";
    case "en":
      return "en";
    case "zh":
      return "cn";
    case "ms":
      return "my";
    case "hi":
      return "www";
    case "lo":
      return "www";
    case "id":
      return "id";
    case "vi":
      return "vn";
    case "fil":
      return "www";
    case "ja":
      return "jp";
    case "ko":
      return "kr";
    default:
      return "en";
  }
};
//
